var map = {
	"./cnn-money-x2.png": 2039,
	"./cnn-money.png": 2244,
	"./economist-x2.png": 2040,
	"./economist.png": 2245,
	"./mashable-x2.png": 2041,
	"./mashable.png": 2246,
	"./tech-crunch-x2.png": 2042,
	"./tech-crunch.png": 2247,
	"./thenewyorker-x2.png": 2043,
	"./thenewyorker.png": 2248,
	"./thrillist-x2.png": 2044,
	"./thrillist.png": 2249,
	"./time-x2.png": 2045,
	"./time.png": 2250,
	"./usa-today-x2.png": 2046,
	"./usa-today.png": 2251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2243;